import { ApiResponse, axiosInstance } from '@/lib/axios';
import { FetchParams, IPagination } from '@/types/general.type';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TChannel } from '../../../_shared/types/channel.type';
// import { TChannel } from '../../_shared/types/channel.type';

export type TGetListIntegrationXResponse = ApiResponse<IPagination<TChannel>>;
export type TGetListIntegrationXParams = FetchParams;

export const getListIntegrationX = async (
  params: TGetListIntegrationXParams
): Promise<TGetListIntegrationXResponse> => {
  const url = '/integration/twitter/org-channel';

  return axiosInstance.get(url, { params });
};

export const GET_LIST_INTEGRATION_X_QUERY_KEY = 'get-list-integration-x';

export const getListIntegrationXQueryOptions = <TData = IPagination<TChannel>>(
  params: TGetListIntegrationXParams,
  select?: (data: TGetListIntegrationXResponse) => TData
) => {
  return queryOptions({
    queryKey: [
      GET_LIST_INTEGRATION_X_QUERY_KEY,
      {
        page: params?.page,
        limit: params?.limit,
        search: params?.search,
        sortDir: params?.sortDir,
      },
    ],
    queryFn: () => getListIntegrationX(params),
    select,
  });
};

// Overload when select is provided - returns transformed type
export function useGetListIntegrationXQuery<TData>(options: {
  params: TGetListIntegrationXParams;
  queryConfig?: QueryConfig<typeof getListIntegrationXQueryOptions<TData>>;
  select: (data: TGetListIntegrationXResponse) => TData;
}): ReturnType<typeof useQuery<TData>>;

// Overload when select is not provided - returns raw API response (even if generic is provided)
export function useGetListIntegrationXQuery(options: {
  params: TGetListIntegrationXParams;
  queryConfig?: QueryConfig<typeof getListIntegrationXQueryOptions<TGetListIntegrationXResponse>>;
}): ReturnType<typeof useQuery<TGetListIntegrationXResponse>>;

// Implementation
export function useGetListIntegrationXQuery<TData = TGetListIntegrationXResponse>({
  queryConfig,
  params,
  select,
}: {
  params: TGetListIntegrationXParams;
  queryConfig?: QueryConfig<typeof getListIntegrationXQueryOptions<TData | TGetListIntegrationXResponse>>;
  select?: (data: TGetListIntegrationXResponse) => TData;
}) {
  return useQuery({
    ...getListIntegrationXQueryOptions(params, select),
    ...queryConfig,
  }) as ReturnType<typeof useQuery<TData extends TGetListIntegrationXResponse ? TGetListIntegrationXResponse : TData>>;
}
